import { Application } from '../../../Models/Application';
import {
  ApplicationsActionType,
  IReceiveApplicationsAction,
  IRequestApplicationsAction,
} from './Applications.action-types';

export function requestApplications(): IRequestApplicationsAction {
  return {
    type: ApplicationsActionType.REQUEST_APPLICATIONS,
  };
}

export function receiveApplications(applications: Application[]): IReceiveApplicationsAction {
  return {
    type: ApplicationsActionType.RECEIVE_APPLICATIONS,
    applications,
  };
}
